/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationConfigOutputCompletionMinLevelsEffectiveAnyOf } from './taskEvaluationConfigOutputCompletionMinLevelsEffectiveAnyOf';

export type TaskEvaluationConfigOutputCompletionMinLevelsEffective =
  TaskEvaluationConfigOutputCompletionMinLevelsEffectiveAnyOf | null;
